export default __webpack_public_path__ + "assets/ico_step_5-cab221e3.svg";